<app-loading *ngIf="loading"></app-loading>

<div class="container" *ngIf="!loading">
  <app-header></app-header>

  <div class="body">
    <app-title (clickClose)="handleBack()"></app-title>
    <ng-template [ngIf]="table.paymentType != 'CUSTOM'">
      <div class="list-container">
        <h3>Resumo dos pedidos</h3>
        <div class="list">
          @if(table.paymentType == 'PARTIAL'){
            @for(section of ownerSections; track section.userId){
              @if(section.name){
                <div class="owner-name">{{ section.name }}</div>
              }
              @for(item of section.items; track item.id){
                <app-item-table [type]="table.paymentType" [item]="item" (increasedItem)="checkCanAdvance()"></app-item-table>
              }
            }
          }@else{
            @for(item of table.items; track item.name){
              @if(!item.tip){
                <app-item-table [type]="table.paymentType" [item]="item" (increasedItem)="checkCanAdvance()"></app-item-table>
              }
            }
          }
          @if(table.paymentType == 'TOTAL' && originalTip){
            <app-item-table [tax]="true" [last]="true" [type]="table.paymentType" [item]="originalTip" (increasedItem)="checkCanAdvance()"></app-item-table>
          }
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="table.paymentType == 'CUSTOM'">
      <div class="custom-payment-container">
        <h3 class="title-large">
          Quanto quer pagar?
        </h3>
      </div>
      <div class="input-container mb-2">
        <input [(ngModel)]="customPayment" type="text" placeholder="R$ 0,00" (keyup)="keyup()" currency>
      </div>
    </ng-template>

    <app-table-values-summary-list
      [customPayment]="customPayment"
      [remainingValue]="table.paymentType === 'CUSTOM' ? remainingAfterCustomPayment : getRemainingValue()"
      [subtotal]="table.paymentType === 'CUSTOM' ? null : getSubtotal()"
      [total]="table.paymentType === 'CUSTOM' ? null : getTotal()"
      [hasCashback]="table.cashbackApplied > 0"
      [cashbackValue]="table.cashbackApplied"
    ></app-table-values-summary-list>
  </div>

  <div class="footer" [class.custom]="table.paymentType == 'CUSTOM'">
    <div class="total" *ngIf="table.paymentType != 'CUSTOM'">
      <h3>Total da conta</h3>
      <div class="value" *ngIf="table.paymentType == 'TOTAL'">
        <span>{{ table.remainingValue | currency }}</span>
        <small>&nbsp;/ {{ table.items.length }} itens</small>
      </div>
      <div class="value" *ngIf="table.paymentType == 'PARTIAL'">
        <span>{{ table.totalItensSelected | currency }}</span>
        <small>&nbsp;/ {{ table.qtyItensSelected }} itens</small>
      </div>
    </div>

    <mnt-button
      variant="emphasis"
      color="primary"
      size="large"
      icon-right="arrow-right"
      [disabled]="!canAdvance"
      (buttonClick)="handleNext()"
      full-width
      label="Próximo"
    ></mnt-button>
  </div>
</div>